// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ai-b","colBig":"styles_colBig__2D5NY","colSmall":"styles_colSmall__3OzrD"};